import type { SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "@/types/database";
import type { Lead, LeadCreateInput } from "@/types/models";

export interface ILeadRepository {
  create(input: LeadCreateInput): Promise<Lead>;
  list(): Promise<Lead[]>;
}

export class LeadRepository implements ILeadRepository {
  constructor(private readonly client: SupabaseClient<Database>) {}

  async create(input: LeadCreateInput): Promise<Lead> {
    const { data, error } = await this.client
      .from("leads")
      .insert({
        full_name: input.fullName,
        email: input.email,
        phone: input.phone ?? null,
        message: input.message ?? null,
        source: input.source ?? "landing",
      })
      .select()
      .single();

    if (error) throw new Error(error.message);
    return this.mapRow(data);
  }

  async list(): Promise<Lead[]> {
    const { data, error } = await this.client
      .from("leads")
      .select("*")
      .order("created_at", { ascending: false });

    if (error) throw new Error(error.message);
    return (data ?? []).map(this.mapRow);
  }

  private mapRow(row: Database["public"]["Tables"]["leads"]["Row"]): Lead {
    return {
      id: row.id,
      fullName: row.full_name,
      email: row.email,
      phone: row.phone,
      message: row.message,
      source: row.source,
      createdAt: row.created_at,
    };
  }
}
